<template>
  <div>
    <b-breadcrumb class="breadcrumb-slash mb-1">
      <b-breadcrumb-item :to="{ name: 'dashboard-1' }">
        {{ $t("HomePage.HomePage") }}
        <!-- Dashboard -->
      </b-breadcrumb-item>
      <b-breadcrumb-item active>
        {{ $t("ProductDetails.TheProductIsSuspended") }}
        <!-- สินค้าถูกระงับ -->
      </b-breadcrumb-item>
    </b-breadcrumb>

    <!-- <user-list-add-new
      :is-add-new-user-sidebar-active.sync="isAddNewUserSidebarActive"
      :role-options="roleOptions"
      :plan-options="planOptions"
      @refetch-data="refetchData"
    /> -->

    <!-- Filters -->
    <!-- <users-list-filters
      :role-filter.sync="roleFilter"
      :plan-filter.sync="planFilter"
      :status-filter.sync="statusFilter"
      :role-options="roleOptions"
      :plan-options="planOptions"
      :status-options="statusOptions"
    /> -->

    <!-- Table Container Card -->
    <b-card no-body class="mb-0">
      <b-tabs class="p-2">
        <b-tab active :title="$t('ProductDetails.TheProductIsSuspended')">
          <div class="m-2">
            <!-- Table Top -->
            <b-row>
              <!-- Per Page -->
              <b-col
                cols="12"
                md="6"
                class="d-flex align-items-center justify-content-start mb-1 mb-md-0"
              >
                <label>
                  {{ $t("ProductDetails.Show") }}
                  <!-- แสดง -->
                </label>
                <v-select
                  v-model="perPage"
                  :dir="$store.state.appConfig.isRTL ? 'rtl' : 'ltr'"
                  :options="perPageOptions"
                  :clearable="false"
                  class="per-page-selector d-inline-block mx-50"
                />
                <label>
                  {{ $t("ProductDetails.Entries") }}
                  <!-- รายการ -->
                </label>
              </b-col>

              <!-- Search -->
              <b-col cols="12" md="6">
                <div class="d-flex align-items-center justify-content-end">
                  <b-form-input
                    v-model="searchQuery"
                    class="d-inline-block mr-1"
                    :placeholder="$t('ProductDetails.Search')"
                  />
                  <!-- <b-button variant="primary" :to="{ name: 'member-add' }">
                <span class="text-nowrap">Add Contact</span>
              </b-button> -->
                </div>
              </b-col>

              <!-- <b-col
                cols="12"
                md="2"
                class="mb-md-0 d-flex"
                style="align-items: center;"
              >
                <b-button variant="primary">
                  + เพิ่มสินค้าใหม่
                </b-button>
              </b-col> -->
            </b-row>
          </div>

          <b-table
            ref="refUserListTable"
            class="position-relative fix-minHeight-table"
            :items="fetchUsers"
            responsive
            :fields="tableColumns_i18n"
            primary-key="id"
            :sort-by.sync="sortBy"
            show-empty
            :empty-text="$t('HomePage.NoMatching')"
            :sort-desc.sync="isSortDirDesc"
          >

        <template #cell(index)="data">
          <div style="text-align: center;">
            {{ (currentPage - 1) * perPage + data.index + 1 }}
            </div>
        </template>

          <template #cell(name)="data">
          <b-media vertical-align="center">
            <!-- <template #aside>
              <b-avatar
                size="32"
                :src="data.item.avatar"
                :text="avatarText(data.item.productName)"
                :to="{ name: 'product-view', params: { id: data.item.id } }"
              />
            </template> -->
            <b-link
              :to="{ name: 'product-edit', params: { id: data.item.id } }"
              class="font-weight-bold d-block"
              style="width: 15rem;"
            >
              {{ data.item.name }}
            </b-link>
          </b-media>
        </template>

        <template #cell(moreOptions)="data">
          <b-badge
            pill
            :variant="`light-${resolveStatusVariant(data.item.moreOptions)}`"
            class="text-capitalize"
          >
            {{ data.item.moreOptions }}
          </b-badge>
        </template>

        <template #cell(status)="data">
          <b-badge
            pill
            :variant="`light-${resolveStatusVariant(data.item.status)}`"
            class="text-capitalize"
          >
            {{ data.item.status }}
          </b-badge>
        </template>

        <template #cell(price)="data">
          <span
            >{{ data.item.price.toLocaleString("en-US") }}
            {{ $t("ProductDetails.Baht") }}
            <!-- บาท -->
          </span>
        </template>

        <template #cell(sales)="data">
          <span
            >{{ data.item.sales.toLocaleString("en-US") }}
            <!-- {{ $t("ProductDetails.Kg") }} -->
            <!-- kg -->
          </span>
        </template>

        <template #cell(stockQuantity)="data">
          <span
            >{{ data.item.stockQuantity.toLocaleString("en-US") }}
            <!-- {{ $t("ProductDetails.Kg") }} -->
            <!-- kg -->
          </span>
        </template>

        <template #cell(isPublished)="data">
          <span>{{ data.item.isPublished == true ? 'เผยแพร่' : 'ไม่เผยแพร่' }}
          </span>
        </template>

        <!-- Column: Actions -->
        <template #cell(actions)="data">
          <b-dropdown
            variant="link"
            no-caret
            :right="$store.state.appConfig.isRTL"
          >
            <template #button-content>
              <feather-icon
                icon="MoreVerticalIcon"
                size="16"
                class="align-middle text-body"
              />
            </template>

            <b-dropdown-item
              :to="{ name: 'product-edit', params: { id: data.item.id } }"
            >
              <feather-icon icon="EditIcon" />
              <span class="align-middle ml-50">
                {{ $t("ProductDetails.Edit") }}
                <!-- Edit -->
              </span>
            </b-dropdown-item>

            <b-dropdown-item @click="deleteitem(data.item.id)">
              <feather-icon icon="TrashIcon" />
              <span class="align-middle ml-50">
                {{ $t("ProductDetails.Delete") }}
              </span>
              {{id}}
            </b-dropdown-item>
            <!-- <b-dropdown-item>
              <feather-icon icon="TrashIcon" />
              <span class="align-middle ml-50">
                {{ $t("ProductDetails.Delete") }}
              </span>
            </b-dropdown-item> -->
          </b-dropdown>
        </template>
          </b-table>
          <div class="mx-2 mb-2">
            <b-row>
              <b-col
                cols="12"
                sm="6"
                class="d-flex align-items-center justify-content-center justify-content-sm-start"
              >
                <span class="text-muted">
                  {{ $t("ProductDetails.Showing") }}
                  <!-- Showing -->
                  {{ dataMeta.from }}
                  {{ $t("ProductDetails.to") }}
                  <!-- to -->
                  {{ dataMeta.to }}
                  {{ $t("ProductDetails.of") }}
                  <!-- of -->
                  {{ dataMeta.of }}
                  {{ $t("ProductDetails.Entries") }}
                  <!-- entries -->
                </span>
              </b-col>
              <!-- Pagination -->
              <b-col
                cols="12"
                sm="6"
                class="d-flex align-items-center justify-content-center justify-content-sm-end"
              >
                <b-pagination
                  v-model="currentPage"
                  :total-rows="totalUsers"
                  :per-page="perPage"
                  first-number
                  last-number
                  class="mb-0 mt-1 mt-sm-0"
                  prev-class="prev-item"
                  next-class="next-item"
                >
                  <template #prev-text>
                    <feather-icon icon="ChevronLeftIcon" size="18" />
                  </template>
                  <template #next-text>
                    <feather-icon icon="ChevronRightIcon" size="18" />
                  </template>
                </b-pagination>
              </b-col>
            </b-row>
          </div>
        </b-tab>
        <!-- <b-tab title="การถอนเงิน ">
      
        </b-tab> -->
      </b-tabs>
    </b-card>
    <b-modal id="modal-center" centered title="Status" ok-only ok-title="Save">
      <b-form-group>
        <v-select
          v-model="selected"
          :dir="$store.state.appConfig.isRTL ? 'rtl' : 'ltr'"
          label="title"
          :options="option"
        />
      </b-form-group>
    </b-modal>
  </div>
</template>

<script>
import {
  BCard,
  BRow,
  BCol,
  BFormInput,
  BButton,
  BTable,
  BMedia,
  BAvatar,
  BLink,
  BBadge,
  BDropdown,
  BDropdownItem,
  BPagination,
  BBreadcrumb,
  BBreadcrumbItem,
  BTabs,
  BTab,
} from "bootstrap-vue";
import vSelect from "vue-select";
import store from "@/store";
import { ref, onUnmounted } from "@vue/composition-api";
import { avatarText } from "@core/utils/filter";
import UsersListFilters from "./productBanComponents/MembersListFilters.vue";
import useUsersList from "./productBanComponents/usePointShopList";
import userStoreModule from "./productBanStoreModule.js";
import UserListAddNew from "./productBanComponents/MemberListAddNew.vue";
import axios, { baseURL } from '@axios'

export default {
  components: {
    UsersListFilters,
    UserListAddNew,

    BCard,
    BRow,
    BCol,
    BFormInput,
    BButton,
    BTable,
    BMedia,
    BAvatar,
    BLink,
    BBadge,
    BDropdown,
    BDropdownItem,
    BPagination,
    BBreadcrumb,
    BBreadcrumbItem,
    vSelect,
    BTabs,
    BTab,
  },
  data() {
    return {
      selected: { title: "Active" },

      option: [{ title: "Active" }, { title: "Inactive" }],
    };
  },
  setup() {
    const USER_APP_STORE_MODULE_NAME = "products-ban";

    // Register module
    if (!store.hasModule(USER_APP_STORE_MODULE_NAME))
      store.registerModule(USER_APP_STORE_MODULE_NAME, userStoreModule);

    // UnRegister on leave
    // onUnmounted(() => {
    //   if (store.hasModule(USER_APP_STORE_MODULE_NAME))
    //     store.unregisterModule(USER_APP_STORE_MODULE_NAME);
    // });

    const isAddNewUserSidebarActive = ref(false);

    const roleOptions = [
      { label: "Admin", value: "admin" },
      { label: "Author", value: "author" },
      { label: "Editor", value: "editor" },
      { label: "Maintainer", value: "maintainer" },
      { label: "Subscriber", value: "subscriber" },
    ];

    const planOptions = [
      { label: "All", value: "" },
      { label: "Seller", value: "Seller" },
      { label: "Buyer", value: "Buyer" },
    ];

    const statusOptions = [
      { label: "All", value: "" },
      { label: "Active", value: "active" },
      { label: "Inactive", value: "inactive" },
    ];

    const {
      fetchUsers,
      tableColumns,
      perPage,
      currentPage,
      totalUsers,
      dataMeta,
      perPageOptions,
      searchQuery,
      sortBy,
      isSortDirDesc,
      refUserListTable,
      refetchData,

      // UI
      resolveUserRoleVariant,
      resolveUserRoleIcon,
      resolveUserStatusVariant,

      // Extra Filters
      roleFilter,
      planFilter,
      statusFilter,
    } = useUsersList();

    return {
      // Sidebar
      isAddNewUserSidebarActive,

      fetchUsers,
      tableColumns,
      perPage,
      currentPage,
      totalUsers,
      dataMeta,
      perPageOptions,
      searchQuery,
      sortBy,
      isSortDirDesc,
      refUserListTable,
      refetchData,

      // Filter
      avatarText,

      // UI
      resolveUserRoleVariant,
      resolveUserRoleIcon,
      resolveUserStatusVariant,

      roleOptions,
      planOptions,
      statusOptions,

      // Extra Filters
      roleFilter,
      planFilter,
      statusFilter,
    };
  },

  computed: {
    tableColumns_i18n() {
      return [
        { key: 'index',
          label: this.$t('ProductDetails.Number')
        },
        {
          key: "productCode",
          label: this.$t("ProductDetails.SKUnumber"),

          sortable: true,
        },
        {
          key: "name",
          label: this.$t("ProductDetails.ProductName"),
          sortable: true,
        },
               {
          key: "categoryName",
          label: this.$t("ProductDetails.ProductCategory"),
          sortable: true,
        },
        {
          key: "price",
          label: this.$t("ProductDetails.Price"),

          sortable: true,
        },
        {
          key: "stockQuantity",
          label: this.$t("ProductDetails.Warehouse"),

          sortable: true,
        },
        {
          key: "sales",
          label: this.$t("ProductDetails.Sales"),

          sortable: true,
        },
        {
          key: "isPublished",
          label: this.$t("ProductDetails.isPublished"),
          sortable: true,
        },
        {
          key: "actions",
          label: this.$t("ProductDetails.Actions"),

          sortable: true,
        },
      ];
    },
  },

    methods: {
      deleteitem(item) {
      console.log('deleteitem', item)

      if (confirm('คุณต้องการที่จะลบสินค้าใช่ไหม ?')) {
        // const userData = getUserData()

        const saveModel = {
          productId: item,
        }

        // console.log('saveModel', saveModel)

        axios.delete(`${baseURL}/api/Product/Delete?productId=${saveModel.productId}&delete`)
          .then(response => {
            if (response.status === 200) {
              this.$router.go(this.$router.currentRoute)
            }
          })
          .catch(error => {
          // this.disabledButton = false
          // this.isShowLoading = false
            this.isLoading = false
            this.showToast('danger', 'XCircleIcon', error)
          })
      }
    },
  },
};
</script>

<style lang="scss" scoped>
.per-page-selector {
  width: 90px;
}
</style>

<style lang="scss">
@import "@core/scss/vue/libs/vue-select.scss";
.fix-minHeight-table {
  min-height: 15rem;
}
</style>
